import { accountFromLocalStorage } from '../utils/account-from-localstorage';

export default class AccountsService {

    [x: string]: any;
    static $inject = ['$localStorage', '$http', '$state', '$window', 'PermPermissionStore', 'AccountService', 'Router'];
    constructor($localStorage, $http, $state, $window, PermPermissionStore, AccountService, Router) {
        this.$localStorage = $localStorage;
        this.$http = $http;
        this.$state = $state;
        this.$window = $window;
        this.PermPermissionStore = PermPermissionStore;
        this.accountService = AccountService;
        this.router = Router;
    }

    setLast() {
        if (this.$localStorage.currentAccount) {
          this.$http.defaults.headers.common.Account = this.$localStorage.currentAccount;
          this.notifyNg2AboutSetAccount();
        }
    }

    notifyNg2AboutSetAccount() {
      // Wait for observers to be available to request for fully configured msisdn
      const tryToNotifyNg2 = () => {
        if (this.accountService.isAccountSet$.observers.length && accountFromLocalStorage()) {
          this.accountService.isAccountSet$.next();
        } else {
          setTimeout(() => {
            tryToNotifyNg2();
          }, 1000);
        }
      }

      tryToNotifyNg2();
    }

    setAccount(account, goTo) {
        this.$localStorage.currentAccount = account.domain;
        this.$localStorage.currentAccountName = account.name;
        this.$http.defaults.headers.common.Account = account.domain;
        this.notifyNg2AboutSetAccount();

        if (goTo) {
          this.router.navigateByUrl(goTo);
        } else {
          this.goToDashboard();
        }
    }

    setAccountsLength(length) {
        this.$localStorage.accountsLength = length;
    }

    getAccountsLength() {
        return this.$localStorage.accountsLength;
    }

    hasAccessToProjectCreator() {
        return this.PermPermissionStore.hasPermissionDefinition('READ_SCRIPT_PERMISSION') &&
            this.PermPermissionStore.hasPermissionDefinition('EDIT_USER_PERMISSION');
    }

    current() {
        return this.$localStorage.currentAccount;
    }

    currentAccountName() {
        return this.$localStorage.currentAccountName;
    }

    goToDashboard() {
      // TODO: from auth service it's still needed
      this.$state.go('app.dashboard');
      this.router.navigateByUrl('/dashboard');
    }

    clear() {
        this.$window.localStorage.clear();
        delete this.$localStorage.currentAccount;
        this.$http.defaults.headers.common.Account = null;
    }
}
